import React from 'react';
import Aboutus from './about';
import './about.scss';

function about() {  
  return (
    <div className="App">
      <Aboutus />
    </div>
  );
}

export default about;